import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Stack,
  Box,
  Typography,
  Tab,
  Tabs,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Trash } from "iconsax-react";

import SegmentList from "../Components/SegmentList";
import CardList from "../Components/CardListStep2";

const { URL_PREFIX } = window;

class VF1Step2 extends React.Component {
  constructor() {
    super();
    this.state = {
      widget: [],
      tabValue: "All Segment",
      initialData: [],
      previousData: [],
      roomAllocationData: [],
      draggedDataLength: 0,
      dataResort: [],
      isDragged: false,
      draggedItem: null,
      draggedRoomType: null,
      guestList: [],
      segmentTypes: [],
    };
  }

  componentWillMount() {
    const { soDetail } = this.props.vf1;

    const userData = soDetail.segments
      ?.map((data) => data);


    const roomAllocationData = soDetail.roomAllocation.map((room) => {
      const data = soDetail.segments.filter(
        (segments) => segments.Room_Allocation__c === room.Id
      );

      return {
        ...room,
        segments: data,
      };
    });



    const roomAllocations = soDetail.roomAllocation.filter(
      (room) => room.Allocation_Status__c !== 'Cancelled'
    )
      .map((room) => {
        const data = soDetail.segments.filter(
          (segments) => segments.RoomType__c === room.RoomType__c
        );
        const segment = soDetail.segments.filter(
          (segments) => segments.Room_Allocation__c === room.Id
        );

        return {
          ...room,
          segmentName: data.length > 0 ? data[0].Segment_Type__c : '',
          segments: segment,
        };
      });

    const draggedDataLength = userData.filter(
      (v) => !v.Room_Allocation__c
    ).length;

    this.setState({ dataResort: soDetail.segments });
    this.setState({ draggedDataLength: draggedDataLength });
    this.setState({ roomAllocationData: roomAllocations });
    this.setState({ initialData: userData });
    this.setState({ previousData: roomAllocationData });
    this.setState({ guestList: soDetail.guestList });

    const groupedSegments = soDetail.segments.reduce((acc, segment) => {
      const segmentType = segment.Segment_Type__c;
      const sharingType = segment.Sharing_Type__c;

      if (!acc[segmentType]) {
        acc[segmentType] = {
          segmentType: segmentType,
          sharingTypes: new Set()
        };
      }

      acc[segmentType].sharingTypes.add(sharingType);

      return acc;
    }, {});

    const segmentTypes = Object.values(groupedSegments).map(group => ({
      segmentType: group.segmentType,
      sharingTypes: Array.from(group.sharingTypes)
    }));

    this.setState({ segmentTypes: segmentTypes });
  }

  getGuest = (data, segment, sharingType) => {
    let result = data
      ?.filter(
        (sharingKnown) =>
          sharingKnown.Segment_Type__c === segment &&
          sharingKnown.Sharing_Type__c === sharingType
      )
      .filter((segmentParents) => {
        return (
          this.state.roomAllocationData.filter((room) => {
            if (room.segments) {
              return room?.segments?.some(
                (item) => item.Id === segmentParents.Id
              );
            } else {
              return false;
            }
          }).length === 0
        );
      });
    if (sharingType === "Unknown") {
      result = data
        .filter(
          (sharingKnown) =>
            sharingKnown.Segment_Type__c === segment &&
            !sharingKnown.Sharing_Type__c
        )
        .filter((segmentParents) => {
          return (
            this.state.roomAllocationData.filter((room) => {
              if (room.segments) {
                return room?.segments?.some(
                  (item) => item.Id === segmentParents.Id
                );
              } else {
                return false;
              }
            }).length === 0
          );
        });
    }
    return result;
  };

  render() {
    const TabPanel = (props) => {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}>
          {value === index && (
            <Box sx={{ p: 3 }}>
              <Typography>{children}</Typography>
            </Box>
          )}
        </div>
      );
    };

    const tabProps = (label) => {
      return {
        label: label,
        value: label,
        id: `simple-tab-${label}`,
        "aria-controls": `simple-tabpanel-${label}`,
        sx: { fontSize: "14px", fontWeight: 600 },
      };
    };

    const handleChange = (event, newValue) => {
      this.setState({ tabValue: newValue });
    };

    const handleOnDrag = (e, user) => {
      this.setState({
        isDragged: true,
        draggedItem: user?.Id,
        draggedRoomType: user,
      });
      e.dataTransfer.setData("widgetType", user?.Id);
    };

    const handleOnDrop = (e, room) => {
      this.setState({
        isDragged: false,
        draggedItem: null,
        draggedRoomType: null,
      });
      e.preventDefault();

      const widgetType = e.dataTransfer.getData("widgetType");
      const newInitialData = this.state.initialData.map((v) => {
        if (v.Id === widgetType) {
          return {
            ...v,
            Room_Allocation__c: room.Id,
          };
        } else {
          return v;
        }
      });

      let error = false;

      const indexRoomAllocationData = this.state.roomAllocationData.findIndex(
        (ar) => ar.Id === room.Id
      );
      const indexGuest = newInitialData.findIndex((ar) => ar.Id === widgetType);
      const tmpRoomAllocationData = [...this.state.roomAllocationData];

      let tmpSegment = [];

      if (
        tmpRoomAllocationData[indexRoomAllocationData].segments === undefined
      ) {

        tmpSegment.push(newInitialData[indexGuest]);
      } else {
        if (
          (tmpRoomAllocationData[indexRoomAllocationData].Sharing_Type__c != 'Single') ||
          (tmpRoomAllocationData[indexRoomAllocationData].segments.length < 1 && tmpRoomAllocationData[indexRoomAllocationData].Sharing_Type__c == 'Single')
        ) {
          tmpSegment = [
            ...tmpRoomAllocationData[indexRoomAllocationData].segments,
          ].concat([newInitialData[indexGuest]]);
        } else {
          tmpSegment = tmpRoomAllocationData[indexRoomAllocationData].segments;
        }
      }

      if (
        tmpRoomAllocationData[indexRoomAllocationData].Sharing_Type__c ===
        newInitialData[indexGuest].Sharing_Type__c &&
        tmpRoomAllocationData[indexRoomAllocationData].RoomType__c ===
        newInitialData[indexGuest].RoomType__c
      ) {

        tmpRoomAllocationData[indexRoomAllocationData].segments = tmpSegment;
      } else {
        if (
          tmpRoomAllocationData[indexRoomAllocationData].Sharing_Type__c ===
          "Share w/person (Known)" &&
          newInitialData[indexGuest].Sharing_Type__c === "Sharing Known"
        ) {
          tmpRoomAllocationData[indexRoomAllocationData].segments = tmpSegment;
        }
      }

      if (!error) {
        this.setState({ roomAllocationData: tmpRoomAllocationData });
        this.setState({ initialData: newInitialData });
        this.setState({ widget: [...this.state.widget, widgetType] });
      }

      const draggedData = this.state.initialData.filter(
        (v) => !v.Room_Allocation__c
      );

      if (draggedData.length === 0) {
        this.setState({ disabled: true });
      } else {
        this.setState({ disabled: false });
      }
    };

    const handleDragOver = (e) => {
      e.preventDefault();
      this.setState({
        isDragged: false,
        draggedItem: null,
        draggedRoomtype: null,
      });
    };

    const getFilterBySegmentType = (data, type) => {
      const notCancelled = data.filter((item) => item?.Allocation_Status__c !== 'Cancelled');

      const roomAllocation = notCancelled.filter((data) => {
        // if (data.segments && data.segments[0]) {
        //   return data.segments[0].Segment_Type__c === type;
        // }
        if (data.segmentName) {
          return data.segmentName === type;
        }
        if (type === "Empty Room") {
          return true;
        }
        return false;

      });
      return roomAllocation;
    };

    const handleDelete = (guestId, roomId) => {
      let tmpRoomAllocationData = [...this.state.roomAllocationData].map(
        (item) => {
          if (item.Id === roomId) {
            let tmpSegment = [...item.segments];
            let indexSegment = tmpSegment.findIndex((ar) => ar.Id === guestId);
            tmpSegment.splice(indexSegment, 1);
            item.segments = tmpSegment;
          }
          return item;
        }
      );
      let tmpInitialData = [...this.state.initialData].map((item) => {
        if (item.Id === guestId) {
          item.Room_Allocation__c = null;
        }
        return item;
      });
      this.setState({
        roomAllocationData: tmpRoomAllocationData,
        initialData: tmpInitialData,
      });
    };

    const clearAllocation = () => {
      let tmpRoomAllocationData = [...this.state.roomAllocationData].map(
        (item) => {
          item.segments = [];
          return item;
        }
      );

      let tmpInitialData = [...this.state.initialData].map((item) => {
        item.Room_Allocation__c = null;
        return item;
      });

      this.setState({
        initialData: tmpInitialData,
        roomAllocationData: tmpRoomAllocationData,
      });
    };

    const onHandleConfirm = () => {
      localStorage.setItem(
        "@wakatobi-allocation",
        JSON.stringify(this.state.roomAllocationData)
      );
    };

    const handleOnChangeRemarks = (e, valueIndex) => {
      const value = e;
      const roomAllocationData = this.state.roomAllocationData;

      const newRoomAllocationData = roomAllocationData.map((data, index) => {
        if (valueIndex === index) {
          data.Remarks__c = value;
          return data;
        } else {
          return data;
        }
      });

      this.setState({ roomAllocationData: newRoomAllocationData });
    };

    const isAllGuestAllocated = () => {
      const allGuest = this.state.dataResort.length;

      let allocatedGuest = 0;
      this.state.roomAllocationData.map((item) => {
        if (item.segments) {
          allocatedGuest += item.segments.length;
        }
      });

      return allGuest === allocatedGuest;
    };

    return (
      <div style={{ margin: "30px" }}>
        <Box sx={{ width: "auto" }}>
          <Typography variant="h4" sx={{ fontWeight: 600, fontSize: "30px" }}>
            Guest Allocation
          </Typography>
        </Box>
        <Box sx={{ width: "auto", marginTop: "10px" }}>
          <Typography
            variant="text-large"
            sx={{
              color: "#667085",
              fontSize: "18px",
              fontWeight: 300,
            }}>
            You can drag and drop the name of guests into the rooms to allocate
            them
          </Typography>
        </Box>
        <Box sx={{ width: "100%" }}>
          <Stack direction="row">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={this.state.tabValue}
                onChange={handleChange}
                aria-label="basic tabs example">
                <Tab
                  {...tabProps('All Segment')}
                />
                {this.state.segmentTypes.map((item) => (
                  <Tab
                    {...tabProps(item.segmentType)}
                  />
                ))}
              </Tabs>
            </Box>
            <Button
              onClick={clearAllocation}
              sx={{
                marginTop: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "8px 14px",
                border: "1px solid #D0D5DD",
                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                borderRadius: "8px",
                width: "auto",
                height: "36px",
              }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "14px",
                  color: "#344054",
                  display: "flex",
                  alignItems: "center",
                  marginRight: "6px",
                }}>
                Clear Allocation
              </Typography>
              <Trash style={{ color: "black" }} />
            </Button>
          </Stack>

          <Stack direction="row">
            <Box
              sx={{
                overflowY: "scroll",
                width: "20%",
                backgroundColor: "#F9FAFB",
                height: "800px",
                padding: "10px",
              }}>
              {this.state.segmentTypes.map((item) => (
                <div key={item.segmentType}>
                  {(this.state.tabValue === "All Segment" || this.state.tabValue === item.segmentType) && (
                    <>
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize: "16px",
                          color: "#101828",
                        }}
                      >
                        {item.segmentType}
                      </Typography>

                      {item.sharingTypes.map((sharingType) => (
                        <SegmentList
                          key={sharingType}
                          sharingType={sharingType}
                          segmentType={item.segmentType}
                          getGuest={this.getGuest}
                          dataResort={this.state.dataResort}
                          handleOnDrag={handleOnDrag}
                          isDragged={this.state.isDragged}
                          draggedItem={this.state.draggedItem}
                        />
                      ))}
                      <br />
                    </>
                  )}
                </div>
              ))}
            </Box>
            <Box
              sx={{
                overflowY: "scroll",
                width: "80%",
                height: "800px",
                padding: "10px",
              }}>
              {this.state.segmentTypes.map((item) => (
                <div key={item.segmentType}>
                  {(this.state.tabValue === "All Segment" || this.state.tabValue === item.segmentType) && (
                    <>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "22px",
                          color: "blue",
                        }}>
                        {item.segmentType}
                      </Typography>
                      <hr />

                      <CardList
                        getFilterBySegmentType={getFilterBySegmentType}
                        roomAllocationData={this.state.roomAllocationData}
                        segmentType={item.segmentType}
                        handleOnDrop={handleOnDrop}
                        handleDragOver={handleDragOver}
                        handleDelete={handleDelete}
                        handleOnChangeRemarks={handleOnChangeRemarks}
                        draggedRoomType={this.state.draggedRoomType}
                      />
                      <br />
                    </>
                  )}
                </div>
              ))}
            </Box>
          </Stack>
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <Stack direction="row" gap={4}>
            <Link
              to={`${URL_PREFIX}/vf1/wizard/`}
              style={{ textDecoration: "none" }}>
              <Button
                onClick={() =>
                  localStorage.setItem(
                    "@stepper",
                    JSON.stringify({
                      guestDetail: "current",
                      guestAllocation: "undone",
                      guestConfirmation: "undone",
                      guestSummary: "undone",
                    })
                  )
                }
                sx={{
                  padding: "12px 20px",
                  width: "77px",
                  height: "48px",
                  background: "#FFFFFF",
                  border: "1px solid #D0D5DD",
                  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                  borderRadius: "8px",
                }}>
                <Typography
                  sx={{ color: "#344054", fontWeight: 600, fontSize: "16px" }}>
                  Back
                </Typography>
              </Button>
            </Link>

            {isAllGuestAllocated() && <Link
              to={`${URL_PREFIX}/vf1/wizard/confirmation`}
              style={{ textDecoration: "none" }}
            >
              <Button
                onClick={onHandleConfirm}
                // disabled={true
                // this.state.initialData.filter((v) => !v.Room_Allocation__c)
                //   .length === 0
                //   ? false
                //   : true
                // isNotAllGuestAllocated
                // }
                sx={{
                  padding: "12px 20px",
                  width: "auto",
                  height: "48px",
                  backgroundColor: "#2F37B5 ",

                  border: "1px solid #D0D5DD",
                  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                  borderRadius: "8px",
                }}>
                <Typography
                  sx={{ color: "#FFFFFF", fontWeight: 600, fontSize: "16px" }}>
                  Confirm
                </Typography>
              </Button>
            </Link>}
          </Stack>
        </Box>
      </div>
    );
  }
}

VF1Step2.propTypes = {
  vf1: PropTypes.object.isRequired,
  nextStep: PropTypes.func.isRequired,
  previousStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = (state) => ({
  vf1: state.vf1,
});

export default connect(mapStateToProps, mapDispatchToProps)(VF1Step2);
